import { graphql } from 'src/graphql';

export const UnreadNotificationsCountByTeam = graphql(`
  query UnreadNotificationsCountByTeam($_team_id: ID!) {
    unreadNotificationsCountByTeam(_team_id: $_team_id) {
      _id
      unread
    }
  }
`);
